<template>
  <div class="media-pages-indicator">
    <div
      v-for="page in pagesCount"
      :key="`page-${page}`"
      class="media-pages-indicator__page"
      :class="{ 'media-pages-indicator__page_active': page - 1 === currentPage }"
      @click="selectPage(page - 1)"
    ></div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  pagesCount: number;
  currentPage: number;
}>();

const emit = defineEmits<{
  (e: 'select-page', page: number): void;
}>();

const selectPage = (page: number) => {
  emit('select-page', page);
};
</script>

<style scoped>
.media-pages-indicator {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 8px;
  border-radius: 14px;
  border: 1px solid transparent;

  &:hover {
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid #e5e5e5;
  }

  &__page {
    width: 12px;
    height: 12px;
    background-color: #f65900;
    border-radius: 6px;
    transition: height 0.3s ease-in-out;
    cursor: pointer;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    &_active {
      height: 30px;
    }
  }
}

@media (--mobile) {
  .media-pages-indicator {
    flex-direction: row;
    gap: 4px;

    &__page {
      transition: width 0.3s ease-in-out;

      &_active {
        height: 12px;
        width: 30px;
      }
    }
  }
}
</style>
